import type { EvalResult } from "@/lib/types";
import { isPass, weakestRating, tonePass } from "@/lib/stepped/ratings";

// Framing for the feedback card header, derived from the rubric checks the
// component already receives — NOT the model's `tone`. This guarantees the
// header can never praise above a "Not yet" button, since the button keys off
// the same weakest-link gate.
// Fallback: when there are no checks (tone-only coach modes), `tone` is the
// sole signal, so `passed` falls back to `tonePass(data.tone)`.
export interface FeedbackGate {
  passed: boolean;
  strongCount: number;
  total: number;
}

export function deriveFeedbackGate(data: EvalResult): FeedbackGate {
  const total = data.checks.length;
  const passed = total > 0 ? isPass(weakestRating(data.checks)) : tonePass(data.tone);
  const strongCount = data.checks.filter((c) => isPass(c.rating)).length;
  return { passed, strongCount, total };
}
